import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../types';

interface AuthState {
  user:        User | null;
  accessToken: string | null;
  isLoggedIn:  boolean;
  setAuth:     (user: User, token: string) => void;
  setAccessToken: (token: string) => void;
  logout:      () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user:        null,
      accessToken: null,
      isLoggedIn:  false,

      setAuth: (user, token) => set({ user, accessToken: token, isLoggedIn: true }),

      setAccessToken: (token) => set({ accessToken: token }),

      logout: () => set({ user: null, accessToken: null, isLoggedIn: false }),
    }),
    {
      name: 'auth',
      partialize: (s) => ({ user: s.user, isLoggedIn: s.isLoggedIn }),  // token stays in memory only
    },
  ),
);
